module.exports = {
  name: '七里香',
  shortName: '七里香',
  //   logo: 'https://successfe.oss-cn-hangzhou.aliyuncs.com/static/ukew_medicine_logo.svg',
  logo: 'https://successfe.oss-cn-hangzhou.aliyuncs.com/static/ukew_medicine_logo_new.svg',
  loginImg: 'https://successfe.oss-cn-hangzhou.aliyuncs.com/static/medicine-login-bg.png',
}
